'use strict';

jQuery(window).on('load',function () {
    jQuery('.preloader').delay(250).fadeOut('slow');
});

jQuery(document).ready(function() {

    /*=============================================== */
    /*   wow
     /* =============================================== */
    var wow = new WOW(
        {
            boxClass:     'wow',
            animateClass: 'animated',
            offset:       0,
            mobile:       true,
            live:         true,
            scrollContainer: null,
            resetAnimation: true,
        }
    );
    wow.init();

    /* ==============================================
     STICKY HEADER
     =============================================== */
    jQuery(window).on('scroll', function () {
        if (jQuery(window).scrollTop() < 100) {
            jQuery('.header').removeClass('sticky');
        } else {
            jQuery('.header').addClass('sticky');
        }
        if (jQuery(window).scrollTop() < 400) {
            jQuery('.back-to-top').removeClass('active');
        } else {
            jQuery('.back-to-top').addClass('active');
        }
    });

    jQuery('a.has_sub_menu').on('click', function(e){
        if (window.matchMedia('(max-width: 992px)').matches){
            e.preventDefault();
            jQuery(this).toggleClass("active_menu");
            jQuery(this).next(jQuery('.sub_menu')).slideToggle();
        }
    });
    /* ==============================================
    Easing move links
     =============================================== */
    jQuery('a.ease[href^="#"]').on('click', function (event) {
        var jQueryanchor = jQuery(this);
        jQuery('html, body').stop().animate({
            scrollTop: jQuery(jQueryanchor.attr('href')).offset().top
        }, 1500, 'easeInOutExpo');
        event.preventDefault();
    });

});
